/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskTypeEnum } from './taskTypeEnum';
import type { ExportedTaskOutputTaskRef } from './exportedTaskOutputTaskRef';
import type { ExportedTaskOutputDescription } from './exportedTaskOutputDescription';
import type { ExportedTaskOutputObjectives } from './exportedTaskOutputObjectives';
import type { ExportedTaskOutputLevel } from './exportedTaskOutputLevel';
import type { ExportedResourceOutput } from './exportedResourceOutput';
import type { ExportedTaskOutputRubric } from './exportedTaskOutputRubric';
import type { ExportedTaskOutputEvaluation } from './exportedTaskOutputEvaluation';

/**
 * Task export format
 */
export interface ExportedTaskOutput {
  type: TaskTypeEnum;
  title: string;
  task_ref?: ExportedTaskOutputTaskRef;
  description?: ExportedTaskOutputDescription;
  objectives?: ExportedTaskOutputObjectives;
  level?: ExportedTaskOutputLevel;
  sort_index?: number;
  resources?: ExportedResourceOutput[];
  rubric?: ExportedTaskOutputRubric;
  evaluation?: ExportedTaskOutputEvaluation;
}
